// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__t28j7","question":"Question_question__Sx5S9","description":"Question_description__1cxDp"};